import { logError } from "@faire/web--source/common/logging";
import getIDVContext from "@faire/web-api--source/endpoints/www/api/help-center/contexts/idv/get";
import { ISelfServeContextIdvResponse } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeContextIdvResponse";

import { apiPromises } from "../../api/apiPromises";
import { NODE_IS_NOT_VISIBLE } from "../../api/consts";
import { SelfServeContext } from "../../types";

import { idvPending } from "./businessRules/identityVerification";

export const AccountVerificationPendingVisibilityFn = (
  _context: SelfServeContext
) => {
  if (!apiPromises.idv) {
    apiPromises.idv = getIDVContext();
  }

  return apiPromises.idv
    .then((contextIdvResponse: ISelfServeContextIdvResponse) => {
      const status = contextIdvResponse.idv_status;
      return idvPending(status);
    })
    .catch((error) => {
      logError(error);
      return NODE_IS_NOT_VISIBLE;
    });
};
